<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "Career",

  metaInfo: { title: "Career" },

  extends: View,

  mixins: [
    LoadSections([
      //"hero-alt6",
      //"career1",
      //"career2",
      //"career3",
      //"career4",
      "academy",
      "info",
    ]),
  ],

  props: {
    id: {
      type: String,
      default: "career",
    },
  },
};
</script>
